import { ComponentRoute } from '@/classes'

const SuperadminCountrySettingRoutes = {
  CountrySettingListView: new ComponentRoute('/superadmin/countrysetting', 'CountrySettingListView'),
  CountrySettingDetail: new ComponentRoute('/superadmin/countrysetting/:countryId', 'CountrySettingDetail'),
  CountrySettingView: new ComponentRoute('/superadmin/countrysetting/:countryId', 'CountrySettingView')
}

export default SuperadminCountrySettingRoutes